import FavoriteRestaurantIdb from '../data/favorite-restaurant-idb'
import { FavoriteButtonTemplate, FavoredButtonTemplate } from '../views/templates/buttons'

const FavoriteButtonPresenter = {
  async init ({ favoriteButtonContainer, restaurant }) {
    this._favoriteButtonContainer = favoriteButtonContainer
    this._restaurant = restaurant

    await this._renderButton()
  },

  async _renderButton () {
    const { id } = this._restaurant

    if (await this._isRestaurantExist(id)) {
      this._renderFavored()
    } else {
      this._renderFavorite()
    }
  },

  async _isRestaurantExist (id) {
    const restaurant = await FavoriteRestaurantIdb.getRestaurant(id)
    return !!restaurant
  },

  _renderFavorite () {
    this._favoriteButtonContainer.innerHTML = FavoriteButtonTemplate()

    const favoriteButton = document.querySelector('#favorite')
    favoriteButton.addEventListener('click', async () => {
      await FavoriteRestaurantIdb.putRestaurant(this._restaurant)
      this._renderButton()
    })
  },

  _renderFavored () {
    this._favoriteButtonContainer.innerHTML = FavoredButtonTemplate()

    const favoriteButton = document.querySelector('#favorite')
    favoriteButton.addEventListener('click', async () => {
      await FavoriteRestaurantIdb.deleteRestaurant(this._restaurant.id)
      this._renderButton()
    })
  }
}

export default FavoriteButtonPresenter
